import { useMantineTheme } from '@mantine/core';
import { TextSkeleton } from '@repo/foundations';

export function FilterSkeleton() {
	const theme = useMantineTheme();
	return <TextSkeleton width={theme.other.space[40]} />;
}
